/*=========================================================================================
  File Name: state.js
  Description: Ordering State
  ----------------------------------------------------------------------------------------
  Item Name: Ordering Module
  Author: Tan Tran
==========================================================================================*/

export default {

  pickupNumber : 0,

  customerName : '',

  phoneNumber : '',

  priority : false,

  ASAP : false,

  pickupTime : null,

  comment : '',

  cart : [],

  estimatedTime : 0,
  

} 